import { render, staticRenderFns } from "./ConsumptionsDetails.vue?vue&type=template&id=1ad6503b&"
import script from "./ConsumptionsDetails.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionsDetails.vue?vue&type=style&index=0&id=1ad6503b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
